"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ingestionRecordSchema = void 0;
exports.ingestionRecordSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['recordNumber'],
    properties: {
        approvedLenderName: {
            type: ['string', 'null'],
            minLength: 1,
            maxLength: 35,
            errorMessage: 'Should be a string with a maximum of 35 characters',
        },
        approvedLenderReferenceNumberCurrent: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        approvedLenderReferenceNumberOriginal: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        arrearsReason: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        borrowerFirstName: {
            type: ['string', 'null'],
            minLength: 1,
            maxLength: 35,
            errorMessage: 'should have maximum length of 35 characters',
        },
        borrowerLastName: {
            type: ['string', 'null'],
            minLength: 1,
            maxLength: 35,
            errorMessage: 'should have maximum length of 35 characters',
        },
        coBorrowerFirstName: {
            type: ['string', 'null'],
            minLength: 1,
            maxLength: 35,
            errorMessage: 'should have maximum length of 35 characters',
        },
        coBorrowerLastName: {
            type: ['string', 'null'],
            minLength: 1,
            maxLength: 35,
            errorMessage: 'should have maximum length of 35 characters',
        },
        currentInterestRate: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        daysInArrearsCount: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        dueDateOfLastCompleteInstallmentPaid: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD',
        },
        hasContactBeenMade: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        institutionNumber: {
            type: ['string', 'null'],
            minLength: 3,
            maxLength: 3,
            errorMessage: 'Should be a string with a length of 3 characters',
        },
        insurerFileNumber: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        occupancyStatus: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        paymentFrequency: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        principalBalance: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressMunicipalityName: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressPostalCode: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressProvince: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressStreetDirection: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressStreetName: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressStreetNumber: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressStreetType: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        propertyAddressUnitNumber: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        recordNumber: {
            type: 'integer',
            errorMessage: 'Should be a integer',
        },
        recoveryStatus: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        remark: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        totalArrearsAmount: {
            type: ['string', 'null'],
            errorMessage: 'Should be a string',
        },
        transitNumber: {
            type: ['string', 'null'],
            minLength: 5,
            maxLength: 5,
            errorMessage: 'Should be a string with a length of 5 characters or null',
        },
    },
};
